import app from './app'
import users from './users'
import auth from './auth'
import agencies from './agencies'
import programs from './programs'
import graduates from './graduates'
import managers from './managers'
import placements from './placements'
import tasks from './tasks'
import dashboard from './dashboard'
import logs from './logs'
import capabilities from './capabilities'

export default {
  app,
  users,
  auth,
  agencies,
  programs,
  graduates,
  managers,
  placements,
  tasks,
  dashboard,
  logs,
  capabilities
}
